import type { RefObject } from 'react';
import { useLayoutEffect, useRef } from 'react';
import { focusIsLost, restoreFocus } from '@/lib/focus';

/** When `ref`'s element unmounts while it contains focus, and focus is lost afterwards, focuses `target()`. */
export function useFocusFallback(
  ref: RefObject<HTMLElement | null>,
  target: () => HTMLElement | null,
): void {
  const latestTarget = useRef(target);
  useLayoutEffect(() => {
    latestTarget.current = target;
  });
  useLayoutEffect(() => {
    const node = ref.current;
    return () => {
      if (!node?.contains(document.activeElement)) return;
      requestAnimationFrame(() => {
        if (focusIsLost()) restoreFocus(latestTarget.current());
      });
    };
  }, [ref]);
}
